/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4"

export const protectedProfileSchema = z.object({
  userId: z.string(),
  username: z.string().min(1).describe("Username"),
  bio: z.string().describe("Encrypted bio data"),
  profilePictureType: z
    .enum(["encrypted-image", "public-image"])
    .describe(
      'Type of profile picture - "encrypted-image", "public-image", or empty string for no profile picture',
    )
    .optional(),
  profilePictureURL: z
    .string()
    .describe("URL to the profile picture in blob storage")
    .optional(),
})
